/* ===== Cenzio — studyo zeminini eritme =====
   Bazi urun fotograflarinin zemini tam beyaz (studyo cekimi), bazilari
   ise gercek oda fotografi. Hepsine ayni islemi uygularsak oda
   fotograflarinin acik duvarlari da bozulur. Bu yuzden her gorseli
   tek tek olcuyoruz: dort kosesinden 4x4'luk ornek aliyoruz, hepsi
   beyazsa gorseli 'kesilebilir' isaretliyoruz ve CSS multiply ile
   zemini krem arka plana eritiyoruz.

   Ayni kural urun sayfasi galerisi, kucuk gorseller, buyutme penceresi
   ve sepet satirlari icin gecerli — boylece hicbir yerde beyaz kutu
   kalmiyor, oda fotograflarina da dokunulmuyor.

   Olcum ayri ve kucuk bir URL uzerinden yapilir (width=120 + czprobe):
   sayfadaki gorselin onbellekte CORS'suz bir kopyasi varsa canvas
   okumasi basarisiz olurdu; ayri URL temiz bir CORS istegi saglar ve
   indirme de cok kucuk olur. Izin yine de yoksa sessizce vazgeceriz —
   gorsel oldugu gibi kalir, asla bozuk bir sonuc cikmaz.
   ============================================================ */
(function () {
  'use strict';

  /* Urun kartlari ve kart ici serit de dahil: bir urunun mockup'lari
     arasinda beyaz studyo cekimleri var; kartta kaydirirken beyaz kutu
     cikiyordu. */
  var SEL = '.product__media img, .thumbnail img, .product-media-modal img, .cart-item__image,'
          + ' .card__media img, .cz-gal__im, .cz-pcard__media img, .cz-tcard__media img';
  var THRESHOLD = 246;
  var MAX_TRIES = 3;
  var cache = Object.create(null);

  function fileKey(url) {
    return (url || '').split('?')[0].split('/').pop();
  }

  /* Olcum icin kucuk, temiz bir URL uret */
  function probeUrl(url) {
    var parts = url.split('?');
    var base = parts[0];
    var v = /(?:^|&)v=([^&]*)/.exec(parts[1] || '');
    return base + '?v=' + (v ? v[1] : '1') + '&width=120&czprobe=1';
  }

  /* true = beyaz zemin, false = degil, null = olculemedi */
  function cornersAreWhite(url) {
    return new Promise(function (resolve) {
      var im = new Image();
      im.crossOrigin = 'anonymous';
      im.onerror = function () { resolve(null); };
      im.onload = function () {
        try {
          var n = im.naturalWidth;
          var m = im.naturalHeight;
          if (!n || !m) return resolve(null);
          var s = 4;
          var c = document.createElement('canvas');
          c.width = s * 2;
          c.height = s * 2;
          var g = c.getContext('2d', { willReadFrequently: true });
          g.drawImage(im, 0, 0, s, s, 0, 0, s, s);
          g.drawImage(im, n - s, 0, s, s, s, 0, s, s);
          g.drawImage(im, 0, m - s, s, s, 0, s, s, s);
          g.drawImage(im, n - s, m - s, s, s, s, s, s, s);
          var d = g.getImageData(0, 0, s * 2, s * 2).data;
          for (var i = 0; i < d.length; i += 4) {
            if (d[i] < THRESHOLD || d[i + 1] < THRESHOLD || d[i + 2] < THRESHOLD) {
              return resolve(false);
            }
          }
          resolve(true);
        } catch (e) {
          resolve(null);
        }
      };
      im.src = probeUrl(url);
    });
  }

  function mark(img) {
    var url = img.currentSrc || img.src;
    if (!url) return;
    var k = fileKey(url);
    if (img.dataset.czFor === k) return;
    img.dataset.czFor = k;

    /* data-cz-cut  : olculdu, beyaz zeminli -> eritilecek
       data-cz-keep  : olculdu, beyaz DEGIL -> dokunulmayacak
       Ikisi de yoksa "olculemedi" demektir. Sepet satirinda CSS varsayilan
       olarak eritiyor ve yalnizca data-cz-keep onu durduruyor; boylece
       olcum engellenen tarayicilarda da beyaz kutu kalmiyor. */
    function uygula(white) {
      if (white) { img.setAttribute('data-cz-cut', ''); img.removeAttribute('data-cz-keep'); }
      else { img.removeAttribute('data-cz-cut'); img.setAttribute('data-cz-keep', ''); }
    }

    if (k in cache) { uygula(cache[k]); return; }
    cornersAreWhite(url).then(function (white) {
      if (white === null) {
        /* olculemedi: sinirli sayida yeniden dene */
        var tries = (parseInt(img.dataset.czTries, 10) || 0) + 1;
        img.dataset.czTries = tries;
        if (tries < MAX_TRIES) img.removeAttribute('data-cz-for');
        delete img.dataset.czFor;
        delete img.dataset.czGoz;   /* bir sonraki tarama yeniden siraya alsin */
        return;
      }
      cache[k] = white;
      uygula(white);
    });
  }

  /* OLCUM SIRAYA GIRER. Her olcum kucuk de olsa bir istek, ve koleksiyon
     sayfasinda 48 kart gorseli var: hepsini sayfa acilirken olcmek 49 istek
     demekti, yani sayfadaki tum gorsel isteklerinin ucte ikisi. Artik bir
     gorsel ekrana 400px yaklasinca olculuyor. Kenar payi dort yana birden
     veriliyor: urun sayfasi galerisi ve kart seridi YATAY kaydiriliyor, yani
     sonraki kare saga dogru bekliyor; yalnizca dikey pay verseydik parmakla
     kaydirirken once beyaz kutu gorunup sonra erirdi.
     Sepet satirlari bunun disinda: sayilari az ve cekmece acilir acilmaz
     dogru gorunmeliler. */
  var gozcu = null;
  function siraya(img) {
    if (img.matches && img.matches('.cart-item__image')) { mark(img); return; }
    if (!('IntersectionObserver' in window)) { mark(img); return; }
    if (img.dataset.czGoz) return;
    if (!gozcu) {
      gozcu = new IntersectionObserver(function (girisler) {
        girisler.forEach(function (g) {
          if (!g.isIntersecting) return;
          gozcu.unobserve(g.target);
          mark(g.target);
        });
      }, { rootMargin: '400px' });
    }
    img.dataset.czGoz = '1';
    gozcu.observe(img);
  }

  function scan() {
    document.querySelectorAll(SEL).forEach(function (img) {
      /* Olcum, sayfadaki gorselin yuklenmesini beklemez: kendi kucuk
         URL'sini src'den uretiyoruz. Onceden yalnizca 'load' olayina
         bagliydi; sepet cekmecesindeki lazy gorsel, dinleyici takilmadan
         yuklenirse hic olculmuyor ve beyaz zemin oldugu gibi kaliyordu. */
      if (img.currentSrc || img.getAttribute('src')) { siraya(img); return; }
      if (img.dataset.czWait) return;
      img.dataset.czWait = '1';
      img.addEventListener('load', function () { siraya(img); }, { once: true });
    });
  }

  function init() {
    scan();
    var t = null;
    function later() { clearTimeout(t); t = setTimeout(scan, 120); }

    if ('MutationObserver' in window) {
      new MutationObserver(later).observe(document.body, { childList: true, subtree: true });
      /* Cekmece acilirken yalnizca sinif degisiyor; childList gozlemcisi
         bunu gormuyordu. Acilisi ayrica dinliyoruz. */
      var cd = document.querySelector('cart-drawer');
      if (cd) {
        new MutationObserver(later).observe(cd, { attributes: true, attributeFilter: ['class', 'open'] });
      }
    }
    document.addEventListener('cart:refresh', later);
    window.addEventListener('pageshow', later);

    /* Gec gelen parcalar icin birkac emniyet taramasi */
    setTimeout(scan, 500);
    setTimeout(scan, 1500);
    setTimeout(scan, 3000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
